import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="datetime"
export default class extends Controller {
  static targets = ["date", "time"];

  connect() {
    this.updateDateTime();
    this.interval = setInterval(() => this.updateDateTime(), 1000);
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  updateDateTime() {
    const now = new Date();

    // Update date
    const date = now.toLocaleDateString("en-US", {
      timeZone: "UTC",
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
    this.dateTarget.textContent = date;

    // UTC time
    const time = now.toLocaleTimeString("en-US", {
      timeZone: "UTC",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    this.timeTarget.textContent = time;
  }
}
